import { render, staticRenderFns } from "./pro-commission-issue.vue?vue&type=template&id=5ea864ce&scoped=true"
import script from "./pro-commission-issue.vue?vue&type=script&lang=js"
export * from "./pro-commission-issue.vue?vue&type=script&lang=js"
import style0 from "./pro-commission-issue.vue?vue&type=style&index=0&id=5ea864ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea864ce",
  null
  
)

export default component.exports